export default __webpack_public_path__ + "static/10-50bfcccc1715f6997cb475820d396166.webp";